import Button from 'components/common/Button';
import Icon from 'components/common/Icon';
import useBottomSheet from 'hooks/common/useBottomSheet';

const NicknameChange = () => {
  const { getSheet, close } = useBottomSheet();
  const changeNickname = getSheet('NicknameChange').data.onConfirm;

  const goToMemberShip = () => {
    close('NicknameChange');
    Transition.showPage(Def.PAGE_MEMBERSHIP);
  };

  const handleChangeNickname = () => {
    close('NicknameChange');
    changeNickname();
  };

  const extractMembershipWord = (text: string) => {
    const match = text.match(/{([^}]+)}/);
    if (!match) return text;
    const full = match[0]; // "{Membership}"
    const Membership = match[1]; // "Membership"
    const [beforeText, afterText] = text.split(full);

    return (
      <>
        {beforeText}
        <em className="text-base-txt-primary">{Membership}</em>
        {afterText}
      </>
    );
  };

  return (
    <>
      <div className="flex flex-col">
        <div className="flex w-full flex-col items-center gap-2">
          <div className="typography-title-lg text-base-txt-primary">Change</div>
          <div className="typography-body-sm text-base-txt-tertiary">{brsc.nick_confirm_ask}</div>
        </div>

        <div className="mb-4 mt-6 flex flex-col items-center justify-center gap-4 rounded-xl bg-base-bg-subtle px-4 py-6">
          <Icon name="profile/membership.svg" size={96} />
          {/* Membership 강조해줘야함 기존에는 em 태그 사용 */}
          <div className="typography-body-sm w-full text-center text-base-txt-tertiary">{extractMembershipWord(brsc.nick_members_desc)}</div>
          <div
            onClick={goToMemberShip}
            className="typography-headline-lg flex w-full items-center justify-center rounded-full border border-solid border-[#585870] px-4 py-3 text-btn-txt-secondary"
          >
            {brsc.nick_members_benefit}
          </div>
        </div>

        <div className="mb-4 flex gap-[2px] p-2">
          <Button
            onClick={handleChangeNickname}
            className="flex-[5]"
            style={{
              text: brsc.change_nick,
              type: 'solid',
              color: 'btn-bg-primary',
              fontColor: 'btn-txt-primary',
              borderRadius: 'full',
            }}
          />
          <Button
            className="flex-[1] rounded-l-md rounded-r-xl"
            onClick={() => close('NicknameChange')}
            style={{
              type: 'solid',
              color: 'btn-bg-normal',
              icon: { name: 'profile/close.svg', size: 24 },
            }}
          />
        </div>
      </div>
    </>
  );
};

export default NicknameChange;
